import { z } from 'zod';
import { env } from '@/env';
import { isNative, tokenSync } from '@/lib/native-auth';

export const anexoRespSchema = z.object({
  anexo_url: z.string(),
  tipo: z.string(),
  anexo_meta: z.unknown(),
});
export type AnexoResp = z.infer<typeof anexoRespSchema>;

// Sobe 1 arquivo (foto/áudio/doc) pro object storage do chat e devolve a URL.
export async function uploadAnexo(blob: Blob, filename: string): Promise<AnexoResp> {
  const fd = new FormData();
  fd.append('file', blob, filename);
  const tk = tokenSync();
  const res = await fetch(`${env.VITE_API_BASE}/api/v2/agentes/anexos`, {
    method: 'POST',
    credentials: 'include',
    headers: { ...(tk ? { Authorization: `Bearer ${tk}` } : {}) },
    body: fd,
  });
  if (!res.ok) throw new Error(`upload HTTP ${res.status}`);
  return anexoRespSchema.parse(await res.json());
}

// Seletor de arquivo genérico (galeria de imagens ou documento). Trata o
// CANCELAMENTO: se o diálogo fecha sem escolher, o input não dispara 'change' e a
// Promise travaria — resolvemos null via evento 'cancel' + fallback no foco.
export function escolherArquivo(accept = '*/*'): Promise<{ blob: Blob; filename: string } | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    let done = false;
    const onFocus = () => window.setTimeout(() => finish(null), 500);
    function finish(v: { blob: Blob; filename: string } | null) {
      if (done) return;
      done = true;
      window.removeEventListener('focus', onFocus);
      resolve(v);
    }
    input.onchange = () => {
      const f = input.files?.[0];
      finish(f ? { blob: f, filename: f.name || 'arquivo' } : null);
    };
    input.oncancel = () => finish(null);
    window.addEventListener('focus', onFocus, { once: true });
    input.click();
  });
}

// URL servida do anexo. No app nativo o <img>/<audio> não manda o header
// Bearer, então vai com base absoluta + ?token= (mesmo padrão das fotos).
export function anexoSrc(url: string): string {
  if (isNative()) {
    const tk = tokenSync();
    return `${env.VITE_API_BASE}${url}${tk ? `?token=${encodeURIComponent(tk)}` : ''}`;
  }
  return url;
}
